import { useState, useEffect, useRef } from "react";
import { Card, CardContent } from "@/components/ui/card";
export default function WhyChooseUs() {
  const ref = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  const checkIcon = <span dangerouslySetInnerHTML={{
    __html: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"></circle><path d="m9 12 2 2 4-4"></path></svg>`
  }} />;
  const starIcon = <span dangerouslySetInnerHTML={{
    __html: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="#F59E0B" stroke="#F59E0B" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>`
  }} />;
  const repairFeatures = [{
    title: "Repairs Done Properly, Priced Fairly",
    description: "No guesswork, no unnecessary parts, no sitting on a waiting list for weeks. Just experienced hands, honest advice, and a machine returned ready to work."
  }, {
    title: "Fast, Honest Turnaround",
    description: "We give you a clear quote before any work begins and aim to have most repairs completed and back with you quickly."
  }, {
    title: "Seasonal Service Packages",
    description: "Get your mower spring-ready or prepare your chainsaw for autumn with a full service package at a set price — no surprises."
  }, {
    title: "Local to Carlisle & Cumbria",
    description: "We're based in Carlisle and serve the surrounding area. Drop-off and collection available — no need to travel far."
  }];
  return <section ref={ref} style={{
    backgroundColor: "rgb(249, 249, 246)",
    backgroundPosition: "0% 0%",
    backgroundRepeat: "repeat",
    color: "rgb(26, 46, 32)",
    fontFamily: "Inter, sans-serif",
    paddingTop: "32px",
    animation: "none 0s ease 0s 1 normal none running"
  }} className="w-full pb-14 !bg-[rgba(255,255,255,1)] md:pb-20">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Playfair+Display:ital,wght@0,400;0,700;1,400;1,700&display=swap');
        @keyframes spin { 100% { transform: rotate(360deg); } }
        @keyframes pulse { 50% { opacity: 0.5; } }
        @keyframes enter {
          0% { opacity: var(--tw-enter-opacity,1); transform: translate3d(var(--tw-enter-translate-x,0),var(--tw-enter-translate-y,0),0)scale3d(var(--tw-enter-scale,1),var(--tw-enter-scale,1),var(--tw-enter-scale,1))rotate(var(--tw-enter-rotate,0)); filter: blur(var(--tw-enter-blur,0)); }
        }
        @keyframes exit {
          100% { opacity: var(--tw-exit-opacity,1); transform: translate3d(var(--tw-exit-translate-x,0),var(--tw-exit-translate-y,0),0)scale3d(var(--tw-exit-scale,1),var(--tw-exit-scale,1),var(--tw-exit-scale,1))rotate(var(--tw-exit-rotate,0)); filter: blur(var(--tw-exit-blur,0)); }
        }
        @keyframes accordion-down {
          0% { height: 0px; }
          100% { height: var(--radix-accordion-content-height, auto); }
        }
        @keyframes accordion-up {
          0% { height: var(--radix-accordion-content-height, auto); }
          100% { height: 0px; }
        }
        @keyframes caret-blink {
          0%, 70%, 100% { opacity: 1; }
          20%, 50% { opacity: 0; }
        }
      `}</style>

      <div className="page-container">
        <div className={`flex flex-col md:flex-row gap-12 md:gap-0 transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="flex-1 flex flex-col justify-center md:pr-16 lg:pr-20">
            <h2 style={{
            color: "rgb(138, 123, 102)",
            fontFamily: "Inter, sans-serif",
            fontSize: "14px",
            fontWeight: "700",
            lineHeight: "20px",
            letterSpacing: "1.4px",
            border: "0px solid rgb(222, 222, 211)",
            textTransform: "uppercase",
            animation: "none 0s ease 0s 1 normal none running",
            marginBottom: "8px"
          }} className="!text-[rgba(65,158,231,1)]">Why Choose Us</h2>

            <h3 style={{
            color: "rgb(26, 46, 32)",
            fontFamily: '"Playfair Display", serif',
            fontSize: "48px",
            fontWeight: "700",
            lineHeight: "48px",
            border: "0px solid rgb(222, 222, 211)",
            animation: "none 0s ease 0s 1 normal none running",
            marginBottom: "16px"
          }}>Reliable Repairs from Engineers Who Know Their Machinery</h3>

            

            <div className="grid md:grid-cols-2 gap-6 p-6 bg-[#f9f9f6] rounded-lg">
              {repairFeatures.map((feature, i) => <Card key={i} data-index={i} className="border-none shadow-sm bg-white rounded-lg">
                  <CardContent className="p-5">
                    <div className="text-[#419ee7] mb-3">
                      {checkIcon}
                    </div>
                    <h4 className="font-bold text-[18px] mb-2 text-[#1a2e20]">{feature.title}</h4>
                    <p className="text-[15px] text-[#5c7062] leading-relaxed">
                      {feature.description}
                    </p>
                  </CardContent>
                </Card>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}